/*
 * Public API Surface of angular-custom-selector
 */

export * from './lib/angular-custom-selector.component';
export * from './lib/angular-custom-selector.module';
